import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b6b9da0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["src", "alt"]

import { ref } from "vue";

interface IProps {
  iconName: string;
  iconCircle: boolean;
  className?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    iconName: {},
    iconCircle: { type: Boolean },
    className: {}
  },
  setup(__props: any) {

const props = __props;



const img = ref();

// NOTE: png only
img.value = require(`@/assets/images/${props.iconName}.png`);

return (_ctx: any,_cache: any) => {
  return (_ctx.iconCircle)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_ctx.className, "icon_circle"])
      }, [
        _createElementVNode("img", {
          class: "icon",
          src: img.value,
          alt: _ctx.iconName
        }, null, 8, _hoisted_1)
      ], 2))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        class: _normalizeClass(["icon", _ctx.className]),
        src: img.value,
        alt: _ctx.iconName
      }, null, 10, _hoisted_2))
}
}

})